import React from 'react';
import styles from './VictoryPointCountBanner.module.scss';
import { T, Tooltip } from '@colonist/ui';
import clsx from 'clsx';
import RibbonSmall from '@static/images/ribbon_small.svg';
import RibbonShort from '@static/images/ribbon_short.svg';
export const VictoryPointCountBanner = ({ className, victoryPointsText, victoryPointsToWin, isLargeRibbon })=>/*#__PURE__*/ React.createElement(Tooltip, {
        className: clsx(styles.victoryPointsContainer, className, {
            [styles.largeRibbon]: isLargeRibbon
        }),
        content: /*#__PURE__*/ React.createElement(T, {
            id: {
                key: 'strings:game.playerInformation.victoryPoint.body',
                options: {
                    count: victoryPointsToWin
                }
            }
        }),
        title: /*#__PURE__*/ React.createElement(T, {
            id: "strings:game.playerInformation.victoryPoint.title"
        })
    }, /*#__PURE__*/ React.createElement("img", {
        className: clsx(styles.ribbon, {
            [styles.largeRibbon]: isLargeRibbon
        }),
        src: isLargeRibbon ? RibbonShort : RibbonSmall
    }), /*#__PURE__*/ React.createElement("span", {
        className: clsx(styles.victoryPoints)
    }, /*#__PURE__*/ React.createElement(T, {
        id: victoryPointsText
    })));
